<template>
  <div class="personal">
    <headd v-if="renderComponent" :mobile_title="mobile_title"></headd>
    <div class="container personal_con">
      <div class="per_cell">
        <div class="cell_name">
          头像：
          <div class="cell_value">
            <img
              class="img"
              :src="
                userinfo.avatarUrl
                  ? userinfo.avatarUrl
                  : '../../../../static/user/icon_1.png'
              "
            />
          </div>
        </div>
        <div class="cell_btn" @click="setImgarr">修改</div>
      </div>
      <div class="per_cell">
        <div class="cell_name">
          昵称：
          <div class="cell_value">{{ userinfo.nickname }}</div>
        </div>
        <div class="cell_btn" @click="dialogFormVisible = true">修改</div>
      </div>
      <div class="per_cell">
        <div class="cell_name">
          账号：
          <div class="cell_value">{{ userinfo.username }}</div>
        </div>
      </div>
      <div class="per_cell">
        <div class="cell_name">
          性别：
          <div class="cell_value">{{ userinfo.sex }}</div>
        </div>
        <div class="cell_btn" @click="gosex()">修改</div>
      </div>
      <div class="per_cell">
        <div class="cell_name">
          投诉建议
        </div>
        <div class="cell_btn" @click="gosugget()">填写</div>
      </div>
      <div class="btn_save" @click="loginout">退出登录</div>
    </div>
    <el-dialog
      title="修改昵称"
      :visible.sync="dialogFormVisible"
      width="6.4rem"
    >
      <div class="cell_form_item">
        <div class="form_item_name">昵称</div>
        <div class="form_input">
          <input type="text" placeholder="请输入" v-model="nickname" />
        </div>
      </div>
      <div class="btn_save_form" @click="btn_nickname">修改</div>
    </el-dialog>

    <el-dialog
      title="修改性别"
      :visible.sync="dialogFormVisible_3"
      width="6.4rem"
    >
      <div class="cell_form_item">
        <div class="form_item_name">性别</div>
        <div class="form_input">
          <div class="cellradio">
            <input type="radio" id="nan" v-model="info.sex" value="男" />
            <label for="nan">男</label>
          </div>
          <div class="cellradio">
            <input type="radio" id="nv" v-model="info.sex" value="女" />
            <label for="nv">女</label>
          </div>
        </div>
      </div>
      <div class="btn_save_form" @click="btn_sex">修改</div>
    </el-dialog>

    <el-dialog title="" :visible.sync="dialogFormVisible_2" width="7rem">
      <suggestion
        :www="www"
        :apiurl="apiurl"
        @suggclose="updateclose"
      ></suggestion>
    </el-dialog>
    <foot></foot>
  </div>
</template>

<script>
let inputElement = null;
import axios from "axios";
import { Loading } from "element-ui";
import { getuserinfoset, getupuserinfo } from "../../api/api"; //引入api里面定义的方法
import headd from "@/components/head_2";
import suggestion from "@/components/suggestion";
import foot from "@/components/foot";
export default {
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      mobile_title: "",
      renderComponent: true,
      userinfo: {},
      dialogFormVisible: false,
      dialogFormVisible_2: false,
      dialogFormVisible_3: false,
      nickname: "",
      info: {
        nickname: "",
        sex: "男"
      },
      www: this.common.www_img,
      apiurl: this.common.apiurl
    };
  },
  components: { headd, suggestion, foot },
  mounted() {
    this.getuserinfoDetail();
  },
  methods: {
    reload() {
      this.renderComponent = false;
      this.$nextTick(function() {
        this.renderComponent = true;
      });
    },
    gosex() {
      this.dialogFormVisible_3 = true;
    },
    gosugget() {
      this.dialogFormVisible_2 = true;
    },
    updateclose(data) {
      console.log(data);
      this.dialogFormVisible_2 = data.dialog; //改变了父组件的值
    },
    setImgarr() {
      var that = this;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }

        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      var _self = this;
      var loadingInstance1 = Loading.service({ fullscreen: true });
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 50;
        const size = files.size / 1024 / 1024;
        //console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$toast("上传图片大小不能超过 50MB!");
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$toast("请选择图片文件");
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          console.log(el.target.files[0]);
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.valueUrl = this.result;
            //console.log(_self.dataURLtoBlob(this.result));

            // 数据传到后台
            const formData = new FormData();
            formData.append("avatarimg", files, files.name); // 通过append向form对象添加数据,可以通过append继续添加数据//或formdata1.append('img',file);
            let config = {
              headers: { "Content-Type": "multipart/form-data" }
            };
            axios
              .post(that.apiurl + "/uploadAvatarImg", formData, config)
              .then(uploadFileRes => {
                console.log(uploadFileRes.data);
                //var res = JSON.parse(uploadFileRes.data);
                //console.log(res.data);
                //that.info.imgJson.push(uploadFileRes.data.data);
                var res = uploadFileRes.data;
                console.log(res);
                if (res.status == 1) {
                  _self.userinfo.avatarUrl =
                    _self.www + uploadFileRes.data.data.thumbfilepath;
                  _self.updatainfo();
                } else {
                  that.$toast(res.msg);
                }

                that.$nextTick(() => {
                  // 以服务的方式调用的 Loading 需要异步关闭
                  loadingInstance1.close();
                });
                inputElement = null;
              });
          };
        }
      }
    },
    async getuserinfoDetail() {
      var _self = this;
      var data = {
        uid: localStorage.getItem("userId")
      };
      const res = await getuserinfoset(data);
      //console.log(res.data.data);
      if (res.data.data) {
        this.userinfo = res.data.data;
        this.nickname = res.data.data.nickname;
        this.info.sex = res.data.data.sex;
      }
    },
    async btn_sex() {
      var sex = this.info.sex;

      var parm = {
        uid: localStorage.getItem("userId"),
        sex: sex
      };
      const res = await getupuserinfo(parm);
      if (res.status == 1) {
        this.$toast({
          message: "修改成功",
          type: "success"
        });
        this.dialogFormVisible_3 = false;
        this.getuserinfoDetail();
      }
    },
    async btn_nickname() {
      var nickname = this.nickname;
      if (nickname == "") {
        this.$toast("请输入昵称");
        return false;
      }
      var parm = {
        uid: localStorage.getItem("userId"),
        nickname: nickname
      };
      const res = await getupuserinfo(parm);
      if (res.status == 1) {
        this.$toast({
          message: "修改成功",
          type: "success"
        });
        this.dialogFormVisible = false;
        localStorage.setItem("nickname", nickname);
        this.getuserinfoDetail();
        this.reload();
      }
    },
    loginout() {
      localStorage.removeItem("sessionToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("nickname");
      localStorage.removeItem("username");
      localStorage.removeItem("avatarUrl");
      localStorage.removeItem("openid");

      this.$router.push({
        path: "/"
      });
    },
    suggest() {
      uni.navigateTo({
        url: "../../suggestion/suggestion"
      });
    },
    updata() {},

    setinfo() {
      var _self = this;
      var nickname = _self.userinfo.nickname;
      uni.navigateTo({
        url: "nickname/nickname?nickname=" + nickname
      });
    },
    setinfoname() {
      var _self = this;
      var uname = _self.userinfo.uname;
      uni.navigateTo({
        url: "uname/uname?uname=" + uname
      });
    },
    setinfosex() {
      var _self = this;
      var sex = _self.userinfo.sex;
      uni.navigateTo({
        url: "sex/sex?sex=" + sex
      });
    },

    async updatainfo() {
      var _slef = this;
      var parm = {
        uid: localStorage.getItem("userId"),
        avatarUrl: _slef.userinfo.avatarUrl
      };

      const res = await getupuserinfo(parm);
      //console.log(res.status);
      if (res.status == 1) {
        _slef.userinfo.avatarUrl = _slef.userinfo.avatarUrl;

        localStorage.setItem("avatarUrl", _slef.userinfo.avatarUrl);
        this.$toast({
          message: "设置成功",
          type: "success"
        });
        this.reload();
      }
    }
  },
  onShow() {
    this.getuserinfoDetail();
    this.$logindex();
    console.log(uni.getStorageSync("userinfo"));
  }
};
</script>

<style lang="less" scoped>
.personal {
  margin: 0 auto 0.6rem;
  flex-direction: column;
  text-align: left;

  @media (max-width: 991px) {
    width: 6.86rem;
  }
  .personal_con {
    width: 8rem;
    margin: auto;
    @media (max-width: 991px) {
      width: 100%;
    }
  }
  .avatar {
    margin-top: 0.4rem;
    margin-bottom: 0.3rem;
    .img {
      width: 1.26rem;
      height: 1.26rem;
      border-radius: 50%;
      margin-bottom: 0.2rem;
    }
    .avatar_btn {
      width: 1.2rem;
      height: 0.4rem;
      background: #1395ff;
      border-radius: 0.2rem;
      font-size: 0.18rem;
      color: #fff;
      line-height: 0.4rem;
      text-align: center;
    }
  }
  .per_cell {
    display: flex;
    justify-content: space-between;
    height: auto;
    padding: 0.3rem 0;
    border-bottom: 1px solid rgba(196, 196, 204, 0.2);
    align-items: center;
    .cell_name {
      font-size: 0.24rem;
      line-height: 0.33rem;
      color: #8d8e99;
      display: flex;
      align-items: center;
      @media (max-width: 991px) {
        font-size: 0.28rem;
        line-height: 0.33rem;
      }
      .cell_value {
        margin-left: 0.4rem;
        color: #1b1c33;
        img {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
        }
      }
    }
    .cell_btn {
      cursor: pointer;
      width: 1.2rem;
      height: 0.4rem;
      background: #1395ff;
      border-radius: 0.2rem;
      font-size: 0.18rem;
      color: #fff;
      line-height: 0.4rem;
      text-align: center;
      @media (max-width: 991px) {
        width: 1.26rem;
        font-size: 0.26rem;
        line-height: 0.4rem;
      }
    }
  }
  .btn_save {
    cursor: pointer;
    margin: 0.5rem auto 0.5rem auto;
    width: 2.94rem;
    height: 0.7rem;
    line-height: 0.7rem;
    background: #1395ff;
    border-radius: 0.35rem;
    font-size: 0.24rem;
    color: #ffffff;
    align-items: center;
    justify-content: center;
    text-align: center;
    @media (max-width: 991px) {
      font-size: 0.28rem;
    }
  }
}
.cell_form_item {
  display: flex;
  align-items: center;
  .form_item_name {
    font-size: 0.14rem;
    margin-right: 0.2rem;
    width: 0.6rem;
    text-align: right;
    @media (max-width: 991px) {
      font-size: 0.28rem;
      line-height: 0.33rem;
    }
  }
  .form_input {
    border-bottom: 0.01rem solid #eeeeee;
    padding: 0.1rem;
    font-size: 0.14rem;
    width: ~"calc(90% - 0.8rem)";
    display: flex;
    input {
      border: none;
      width: 100%;
      height: 100%;
      @media (max-width: 991px) {
        font-size: 0.28rem;
        line-height: 0.33rem;
      }
    }
  }
}
.btn_save_form {
  margin: 0.3rem auto 0rem auto;
  width: 1.4rem;
  height: 0.4rem;
  line-height: 0.4rem;
  background: #1395ff;
  border-radius: 0.2rem;
  font-size: 0.14rem;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  text-align: center;
  @media (max-width: 991px) {
    font-size: 0.26rem;
  }
}
.cellradio {
  margin-right: 0.2rem;
  font-size: 0.18rem;
  display: flex;
  align-items: center;
  @media (max-width: 991px) {
    font-size: 0.28rem;
  }
  input[type="radio"] {
    width: 0.18rem;
    height: 0.18rem;
    margin: 0 0.1rem 0 0;
    @media (max-width: 991px) {
      width: 0.28rem;
      height: 0.28rem;
    }
  }
  label {
    font-weight: normal;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/personal/personal.vue